import { array, object, ref, number, string } from 'yup';

import { passwordMinimumLength } from './constants';

import translations from '../languages/i18n';

// Validations Schemas

export const changePasswordVS = object().shape({
  // currentPassword: string()
  //  .required(translations['_currentPasswordRequired']),
  newPassword: string()
    .required(translations['_newPasswordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
  confirmPassword: string()
    .oneOf([ref('newPassword')], translations['_passwordsDontMatch'])
    .required(translations['_passwordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
});

export const newClinicianDetailsVS = object().shape({
  username: string()
    .required(translations['_usernameRequired']),
  password: string()
    .required(translations['_passwordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
  confirmPassword: string()
    .oneOf([ref('password')], translations['_passwordsDontMatch'])
    .required(translations['_confirmPasswordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
  email: string()
    .required(translations['_emaildRequired'])
    .email(translations['_incorrectEmailFormat']),
});

export const newPasswordVS = object().shape({
  newPassword: string()
    .required(translations['_newPasswordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
  confirmPassword: string()
    .oneOf([ref('newPassword')], translations['_passwordsDontMatch'])
    .required(translations['_passwordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
});

export const newPatientDetailsVS = object().shape({
  username: string()
    //.matches(/^[^\\s]*$/, 'La cadena no debe contener espacios en blanco')
    // .matches(/\\s+/, 'La cadena debe contener al menos un espacio en blanco')
    .required(translations['_usernameRequired']),
  password: string()
    .required(translations['_passwordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
  confirmPassword: string()
    .oneOf([ref('password')], translations['_passwordsDontMatch'])
    .required(translations['_confirmPasswordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
  // email: string()
  //  .required(translations['_emaildRequired'])
  //  .email(translations['_incorrectEmailFormat']),
  height: number()
    .typeError(translations['_mustBeNumber'])
    .integer(translations['_mustBeInteger'])
    .moreThan(0, translations['_moreThanZero']),
  weight: number()
    .typeError(translations['_mustBeNumber'])
    .integer(translations['_mustBeInteger'])
    .moreThan(0, translations['_moreThanZero']),
});

export const newPatientEventVS = object().shape({
  type: string()
    .required(translations['_eventTypeRequired']),
  assignedTo: string()
    .required(translations['_assignedToRequired']),
  date: string()
    .required(translations['_dateRequired']),
});

export const newProgramDetailsVS = object().shape({
  name: string()
    .required(translations['_programNameRequired']),
});

export const resetPasswordVS = object().shape({
  username: string()
    .required(translations['_usernameRequired']),
  newPassword: string()
    .required(translations['_newPasswordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
  confirmPassword: string()
    .oneOf([ref('newPassword')], translations['_passwordsDontMatch'])
    .required(translations['_passwordRequired'])
    .min(passwordMinimumLength, translations['_passwordMinimumLength']), // ATENCIÓ: pensa a canviar el missatge si modifiques el numero mínim de caracters, actualment és 6
});

export const updateClinicianDetailsVS = object().shape({
  username: string()
    .required(translations['_usernameRequired']),
  email: string()
    .required(translations['_emaildRequired'])
    .email(translations['_incorrectEmailFormat']),
});

export const updatePatientDetailsVS = object().shape({
  username: string()
    //.matches(/^[^\\s]*$/, 'La cadena no debe contener espacios en blanco')
    // .matches(/\\s+/, 'La cadena debe contener al menos un espacio en blanco')
    .required(translations['_usernameRequired']),
  // email: string()
  //  .required(translations['_emaildRequired'])
  //  .email(translations['_incorrectEmailFormat']),
  height: number()
    .typeError(translations['_mustBeNumber'])
    .integer(translations['_mustBeInteger'])
    .moreThan(0, translations['_moreThanZero']),
  weight: number()
    .typeError(translations['_mustBeNumber'])
    .integer(translations['_mustBeInteger'])
    .moreThan(0, translations['_moreThanZero']),
});

// ATENCIÓ: el nom de les propietats han d'estar en majúscula. És com estan al servidor
// TODO: aquest validationSchem s'hauria de construir dinàmicament a partir de les variables del formulari a mostrar
/* export const userFormVS = object().shape({
  AGE: string()
    .required(translations['_fieldRequired']),
  DIAGDATE: string()
    .required(translations['_fieldRequired']),
  PSA: number()
    .typeError(translations['_mustBeNumber'])
    .required(translations['_fieldRequired']),
  TNMCT: string()
    .required(translations['_fieldRequired']),
  TNMCN: string()
    .required(translations['_fieldRequired']),
  BIOPCORE: number()
    .typeError(translations['_mustBeNumber'])
    .required(translations['_fieldRequired']),
  BIOPPOS: number()
    .typeError(translations['_mustBeNumber'])
    .required(translations['_fieldRequired']),
  BIOPINVOL: number()
    .typeError(translations['_mustBeNumber'])
    .required(translations['_fieldRequired']),
   GLEASONBIOP1: number()
    .typeError(translations['_mustBeNumber'])
    .integer(translations['_mustBeInteger'])
    .min(1, translations['_minimum1'])
    .max(5, translations['_maximum5'])
    .required(translations['_fieldRequired']),
  GLEASONBIOP2: number()
    .typeError(translations['_mustBeNumber'])
    .integer(translations['_mustBeInteger'])
    .min(1, translations['_minimum1'])
    .max(5, translations['_maximum5'])
    .required(translations['_fieldRequired']),
  COMORB: array()
    .required(translations['_fieldRequired']),
}); */
